import ApplicationController from 'javascript/controllers/application_controller';
import { loginWithFacebook, loginWithGoogle } from 'javascript/utils/oauth';
import { Rails } from 'javascript/utils/rails_polyfills';

export default class extends ApplicationController {
  static targets = ['errorContainer', 'error', 'input'];

  facebook() {
    loginWithFacebook(this.onSuccess);
  }

  google() {
    loginWithGoogle(this.onSuccess);
  }

  beforeSubmit() {
    this.element.classList.add('contents-loading');
  }

  submitSuccess({ detail: [, , xhr] }) {
    this.removeLoadingIndicator();
    this.onSuccess(xhr.getResponseHeader('Location'));
  }

  removeError() {
    this.errorContainerTarget.innerHTML = '';
  }

  submitError({ detail: [response, , xhr] }) {
    this.removeLoadingIndicator();

    let errors;
    switch (xhr.status) {
      case 422:
        errors = response.errors;
        break;
      case 401:
        errors = { email: ['Email or password is incorrect'] };
        break;
    }

    this.errorContainerTarget.classList.remove('util-hidden');
    this.errorTarget.innerHTML = Object.keys(errors).reduce(
      (string, key) => `
      ${string}
      <div>${errors[key][0]}</div>
    `,
      '',
    );

    [].forEach.call(this.inputTargets, (input) => {
      if (errors[input.dataset.field]) {
        input.classList.add('has-error');
      } else {
        input.classList.remove('has-error');
      }
    });
  }

  removeLoadingIndicator() {
    this.element.classList.remove('contents-loading');
  }

  onSuccess = (url) => {
    Rails.fire(this.element, 'howler:session.success', [url]);
  };
}
